import { OutDebt, useGetProductNumberDefQuery } from '../generated/graphql';
import { getNegBooleans } from './getNegBooleans';

export const useGetProductNumberDef = (outDebt: OutDebt | undefined | null) => {
  const { extra, id, negotiation } = outDebt || {} as OutDebt;
  const { isVirtualDebt, isBogota } = getNegBooleans(outDebt as OutDebt);

  const usedOutDebt = !isVirtualDebt
    ? outDebt : extra?.children?.sort((a, b) => (b.balance || 0) - (a.balance || 0))[0];

  const { data } = useGetProductNumberDefQuery({
    variables: { outDebtId: usedOutDebt?.id || id },
    skip: !outDebt || (!negotiation && !isBogota),
  });

  const obfuscateChars = '**** **** ';
  const obfuscatedProductNumber = usedOutDebt?.productNumber
    ? `${obfuscateChars}${usedOutDebt.productNumber}`
    : '';

  return data?.getProductNumberDef || obfuscatedProductNumber;
};
